/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/244-baffled': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"/><path pid="1" d="M6 6.5a.5.5 0 11-1 0 .5.5 0 011 0z"/><path pid="2" d="M5.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 015.5 5zm0-1C4.122 4 3 5.122 3 6.5S4.122 9 5.5 9 8 7.878 8 6.5 6.878 4 5.5 4zM11 6.5a.5.5 0 11-1 0 .5.5 0 011 0z"/><path pid="3" d="M10.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0110.5 5zm0-1C9.121 4 8 5.122 8 6.5S9.121 9 10.5 9 13 7.878 13 6.5 11.879 4 10.5 4zM6 11h4v1H6v-1z"/>'
  }
})
